import { Link } from "react-router-dom";

const Footer = () => {
    return (
        <footer className="site-footer pt-5 pb-3 mt-5 shadow-lg">
            <div className="container">
                <div className="row g-4">
                    {/* Branding Column */}
                    <div className="col-lg-4 col-md-6">
                        <div className="footer-branding mb-4">
                            <div className="d-flex align-items-center mb-3">
                                <img src="/logo.png" alt="familytopup" width="50" height="50" className="me-2 rounded-circle shadow-sm" />
                                <h4 className="fw-bold mb-0">FamilyTopUp</h4>
                            </div>
                            <p className="footer-desc pe-lg-4">
                                FamilyTopUp adalah platform top up game dan voucher digital termurah dan terpercaya di Indonesia.
                                Kami menyediakan layanan cepat dan aman untuk berbagai kebutuhan gaming Anda.
                            </p>
                        </div>
                    </div>

                    {/* Hubungi Kami Column */}
                    <div className="col-lg-3 col-md-6">
                        <h6 className="footer-title">Hubungi Kami</h6>
                        <ul className="footer-links-list">
                            <li>
                                <a href="mailto:topupfamily30@gmail.com" className="footer-contact-item">
                                    <i className="bi bi-envelope-fill me-2"></i>topupfamily30@gmail.com
                                </a>
                            </li>
                            <li>
                                <a href="https://wa.me/628131091521" target="_blank" rel="noreferrer" className="footer-contact-item">
                                    <i className="bi bi-whatsapp me-2"></i>Chat WhatsApp
                                </a>
                            </li>
                        </ul>
                    </div>

                    {/* Informasi Column */}
                    <div className="col-lg-2 col-md-6">
                        <h6 className="footer-title">Informasi</h6>
                        <ul className="footer-links-list">
                            <li><Link to="/termscondition">Syarat &amp; Ketentuan</Link></li>
                            <li><Link to="/privacypolicy">Kebijakan Privasi</Link></li>
                            <li><Link to="/about">Tentang Kami</Link></li>
                        </ul>
                    </div>

                    {/* Payment & Social Column */}
                    <div className="col-lg-3 col-md-6">
                        <h6 className="footer-title">Metode Pembayaran</h6>
                        <div className="footer-payment-grid mb-4">
                            <img src="https://images.duitku.com/hotlink-ok/DA.PNG" alt="DANA" />
                            <img src="https://images.duitku.com/hotlink-ok/OV.PNG" alt="OVO" />
                            <img src="https://images.duitku.com/hotlink-ok/SHOPEEPAY.PNG" alt="ShopeePay" />
                            <img src="https://upload.wikimedia.org/wikipedia/commons/a/a2/Logo_QRIS.svg" alt="QRIS" />
                            <img src="https://images.duitku.com/hotlink-ok/BCA.SVG" alt="BCA" />
                            <img src="https://images.duitku.com/hotlink-ok/MV.PNG" alt="Mandiri" />
                        </div>
                        
                        <h6 className="footer-title">Ikuti Kami</h6>
                        <div className="footer-social-links">
                            <a href="https://www.instagram.com/farosal12/" target="_blank" rel="noreferrer" title="Instagram"><i className="bi bi-instagram"></i></a>
                            <a href="https://www.tiktok.com" target="_blank" rel="noreferrer" title="TikTok"><i className="bi bi-tiktok"></i></a>
                        </div>
                    </div>
                </div>

                <hr className="footer-divider my-4" />

                <div className="footer-bottom text-center">
                    <p className="copyright-text mb-0">
                        © {new Date().getFullYear()} <strong>FamilyTopUp</strong>. All rights reserved.
                    </p>
                </div>
            </div>
        </footer>
    )
}
export default Footer;
